class GoogleMap extends HTMLElement {
  constructor() {
    super();

    this.options = null;
    this.image = this.parentNode.querySelector('.load-error-image');

    try {
      this.options = JSON.parse(this.getAttribute('data-settings'));
    } catch {
      this.setAttribute('hidden', '');
      return;
    }

    if (this.options['apiKey'] && this.options['mapAddress']) {
      this.loadScript().then(this.initMap.bind(this));
    }
  }

  loadScript() {
    return new Promise( (resolve, reject) => {
      var script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${ this.options['apiKey'] }`;
    });
  }

  initMap() {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      {
        address: this.options['mapAddress']
      },
      function (results, status) {
        console.log(status);
        console.log(results);
        if (status === google.maps.GeocoderStatus.OK) {
          this.image.classList.add('hidden');
          this.image.classList.remove('no-js-visible');

          const mapOptions = {
            zoom: this.options['zoom'],
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          };
          const map = new google.maps.Map(this, mapOptions);
          const icon = {
            path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
            fillColor: this.options['markerColor'],
            fillOpacity: 1,
            anchor: new google.maps.Point(15, 55),
            strokeWeight: 0,
            scale: 0.6
          };

          map.setCenter(map.getCenter());

          new google.maps.Marker({
            map: map,
            position: map.getCenter(),
            icon: icon
          });

          google.maps.event.addDomListener(window, 'resize', () => {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(map.getCenter());
          });
        }
      }.bind(this)
    );
  }
}

customElements.define('google-map', GoogleMap);